import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { ILoginForm } from 'src/app/core/login/form-data.interface';
import { IOrgan, IOrgansMe, Profile } from 'src/app/shared/interfaces/index.interface';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService, LocalStorageService } from '../index.service';
import { FinancialService } from '../api/financial.service';
type LogState = boolean | 'loading'
@Injectable({
  providedIn: 'root'
})
export class JwtService {
  private loggedIn: LogState = 'loading';
  private currentUser?: Profile | null;
  private currentAccount?: Profile | null;
  private currentAccountSubject: BehaviorSubject<Profile | null> = new BehaviorSubject(<Profile | null>{})
  private currentAccountObs: Observable<Profile | null> = this.currentAccountSubject.asObservable().pipe(
    // skip(1),
    // share(),
  )
  private currentOrgan?: IOrgan | null;
  public Organs?: any = [];
  private subscription: Subscription[] = [];
  private token: any;
  private accessJWTtoken?: string;
  private refreshJWTtoken?: string;
  public destination?: string;
  public balanceValueSub: Subject<number> = new Subject();
  public delayToken = new BehaviorSubject(false);
  readonly BASE_URL = environment.BASE_API_URL;
  public pageStatue: boolean = false;
  public errorServerObj: { status: boolean, errorObj: any } = { status: false, errorObj: null }
  private jwtService: JwtHelperService = new JwtHelperService()
  constructor(
    private http: HttpClient,
    public storage: LocalStorageService,
    private router: Router,
    private toster: ToastrService,
    private errorHandlingService: ErrorHandlingService
  ) { }
  createTokenLogin(data: ILoginForm) {
    return this.http.post(`${this.BASE_URL}auth/jwt/create/`, data).pipe(
      map((token: any) => {
        this.distributionToken(token);
        this.createNewTokenWithInterval(token);
        return this.decodeToken(token['access'])
      })
    )
  }
  distributionToken(token: any) {
    this.storage.setData('token', token)
    this.setToken(token);
    this.setAccessToken(token);
    this.setRefreshToken(token);
  }
  decodeToken(token: string) {
    return this.jwtService.decodeToken(token)
  }
  verifyAccessToken(accessToken: string) {
    return this.http.post(`${this.BASE_URL}auth/jwt/verify/`, { token: accessToken })
  }
  refreshToken(refreshToken: string) {
    let data: { refresh: string } = { refresh: refreshToken }
    return this.http.post(`${this.BASE_URL}auth/jwt/refresh/`, data)
  }
  changeRole(refreshToken: string, username: string | null) {
    let data: { refresh: string, organ?: string } = { refresh: refreshToken }
    if (username) data.organ = username
    return this.http.post(`${this.BASE_URL}auth/jwt/change_role`, data)
  }
  setAccessToken(token: any) {
    this.accessJWTtoken = token['access'];
  }
  getAccessToken() {
    return this.accessJWTtoken as string
  }
  setRefreshToken(token: any) {
    this.refreshJWTtoken = token['refresh'];
  }
  getRefreshToken() {
    return this.refreshJWTtoken as string;
  }
  getAuthMeUserDetail() {
    return this.http.get<IOrgansMe>(`${this.BASE_URL}organ/o/me/`)
  }
  setCurrentAccountData(data: Profile | null) {
    this.currentAccount = data;
    this.currentAccountSubject.next(data)
  }
  setCurrentUserData(data: Profile | null) {
    this.currentUser = data;
  }
  setOrgans(data: IOrgan[] | null) {
    this.Organs = data;
  }
  setSelectedOrganData(data: IOrgan | null) {
    this.currentOrgan = data;
  }
  setToken(token: any) {
    this.token = token
  }
  getToken() {
    return this.token;
  }
  getCurrentAccountData(): any {
    return this.currentAccount;
  }
  getCurrentAccountDataObs(): Observable<Profile | null> {
    return this.currentAccountObs;
  }
  getCurrentUserData(): any {
    // console.log(this.currentUser)
    return this.currentUser;
  }
  getSelectedOrganData(): any {
    return this.currentOrgan;
  }
  subscribegetCurrentAccountData() {
    this.getAuthMeUserDetail().subscribe(
      (data) => {
        this.balanceValueSub.next(data.wallet.balance)
        this.login()
        this.setCurrentUserData(Object.assign({}, <Profile>{...data.user,last_logined_role:this.storage.getData('identity').role}));
        data.user.last_logined_role = this.storage.getData('identity').role
        data.user.last_logined_role_username = <string>this.storage.getData('identity').username
        this.setOrgans(<IOrgan[]>data.organs);
        this.findSelectedOrgan(<IOrgan[]>data.organs, <Profile>data.user);
        this.convertEntityDetail(data.user?.last_logined_role)
      },
      (error) => {
        if (error.status == 500 || error.status == 502 || error == 0 || error.status == 0) {
          this.setErrorServerStatus(true, this.errorHandlingService.getErrorObj(error))
        }
      }
    )
  }
  setErrorServerStatus(bool: boolean, errorObj: any) {
    this.errorServerObj = { status: bool, errorObj: errorObj }
  }
  getErrorServer() {
    return this.errorServerObj
  }
  setHeaders(token: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', `Bearer ${token}`)
    headers = headers.append('Accept-Language', 'fa')
    return headers
  }
  checkAuth() {
    return this.loggedIn;
  }
  login() {
    this.loggedIn = true;
  }
  setLoggedIn(val: boolean) {
    this.loggedIn = val
  }
  logout() {
    this.storage.removeItem('token');
    this.storage.removeItem('identity');
    sessionStorage.removeItem('temp_identity')
    this.getCurrentAccountData().last_logined_role = "USER"
    this.getCurrentAccountData().last_logined_role_username = ""
    this.loggedIn = false;
    this.currentUser = null;
    this.currentOrgan = null;
    this.currentAccount = null;
    this.currentAccount = <Profile>{}
    this.currentAccountSubject.next(<Profile>{})
    this.getCurrentAccountData().last_logined_role = "USER"
    window.scroll(0, 0);
    this.router.navigate(['/auth/login'])
    this.subscription.forEach(sub => sub.unsubscribe())
  }
  createNewToken() {
    return this.refreshToken((this.getRefreshToken() as string))
  }
  recreacteNewTokenPerRequest() {
    if (this.jwtService.isTokenExpired(this.getAccessToken())) {
      this.refreshToken((this.getRefreshToken() as string)).subscribe(
        (newRefresh) => {
          this.distributionToken(newRefresh)
          this.setHeaders((this.getAccessToken() as string))
        },
        (err) => {
          console.error(err)
          // this.dialog.open(ReportResultComponent,{
          //   data:{
          //     succesful:true,
          //     message:'شما باید مجدد وارد حساب خود شوید'
          //   }
          // })
          if (err.status == 401) this.logout()
        }
      )
    }
    else {
      this.distributionToken(this.getToken())
      this.setHeaders((this.getAccessToken() as string))
    }
  }
  recreacteNewTokenReloadPage(token: any) {
    if (this.jwtService.isTokenExpired(token['access'])) {
      this.login();
      this.distributionToken(token);
      this.setHeaders((token['access'] as string))
      this.refreshToken(token['refresh']).subscribe(
        (refreshToken: any) => {
          // this.login();
          this.distributionToken(refreshToken);
          this.setHeaders((this.getAccessToken() as string))
          this.subscribegetCurrentAccountData();
          // this.createNewTokenWithInterval(refreshToken);
        },
        (err) => {
          console.error(err)
          if (err.status == 401) { this.logout(); this.toster.error('', 'باید مجدد وارد حساب کاربری شوید') }
        }
      )
    } else {
      this.login();
      this.distributionToken(token);
      this.setHeaders((token['access'] as string))
      this.subscribegetCurrentAccountData();
      // this.createNewTokenWithInterval(token);

    }
  }
  TokenListener(token: any) {
    if (!this.pageStatue) {
      this.subscribegetCurrentAccountData();
    }
  }
  createNewTokenWithInterval(token: any) {
    this.subscription.push(timer(0, 200000).subscribe(time => {
      if (this.jwtService.isTokenExpired(this.getAccessToken())) {
        this.refreshToken((this.getRefreshToken() as string)).subscribe(
          (newToken: any) => {
            this.distributionToken(newToken)
            this.setHeaders(newToken['access'] as string)
          },
          (err) => {
            console.error(err)
            if (err.status == 401) this.logout()
          }
        )
      }
    }));
  }
  // accessShowToCurrentUser(username:string){
  //   return this.getCurrentAccountData()?.username === username
  // }
  accessShowToCurrentUserObs(username: string): Observable<boolean> {
    return this.currentAccountObs.pipe(
      map((acccount: any) => {
        if (acccount['username'])
          return acccount['username'] == username
        else return false
      })
    )
  }
  setHeadersWhenSendHttpRequest() {
    let token = this.getToken();
    if (token) {
      return { is_set_token: true, headers: this.setHeaders(token['access'] as string) }
    } else {
      return { is_set_token: false, headers: {} }
    }
  }
  checkRoleIsOrgan() {
    if (this.checkAuth() && this.getCurrentAccountData()?.last_logined_role == 'ORGAN') return true;
    else return false;
  }
  checkRoleIsPerson() {
    if (this.checkAuth() && this.getCurrentAccountData()?.last_logined_role == 'USER') return true;
    else return false;
  }
  checkPersonRoleUsername(username: string) {
    return this.getCurrentAccountData()?.last_logined_role == 'USER' && this.getCurrentAccountData()?.username == username;
  }
  checkOrganRoleUsername(username: string) {
    return this.getCurrentAccountData()?.last_logined_role == 'ORGAN' && this.getCurrentAccountData()?.username == username;
  }
  convertEntityDetail(role: string | undefined) {
    let convertData: any = Object.assign({},this.getCurrentUserData());
    if (role == 'USER') {
      this.setCurrentAccountData(convertData);
    } else {
      convertData.username = this.getSelectedOrganData().username;
      convertData.banner_photo = this.getSelectedOrganData().banner;
      convertData.profile_photo = this.getSelectedOrganData().logo;
      convertData.org_banner_photo = this.getSelectedOrganData().org_banner;
      convertData.org_profile_photo = this.getSelectedOrganData().org_logo;
      convertData.first_name = this.getSelectedOrganData().name;
      convertData.last_name = '';
      convertData.profile_text = this.getSelectedOrganData().slogan;
      convertData.info = this.getSelectedOrganData().description;
      this.setCurrentAccountData(convertData);
    }
  }
  findSelectedOrgan(organs: IOrgan[], user: Profile | null = this.getCurrentAccountData()) {
    organs.filter(item => {
      if (item.username == user?.last_logined_role_username) {
        this.setSelectedOrganData(item)
      }
    })
  }
  getOrgans() {
    return this.Organs;
  }
  getUsernameFromStorageToken() {
    let token = this.storage.getData('token');
    if (!token)
      this.loggedIn = false;
    return this.decodeToken(token['access']).username
  }
} 